import { ReauthorizationEcshopApi } from "@/features/accounts/ecshop/services/reauthorization-api";
import { ReauthorizationEcshopRequestModel } from "@/features/accounts/ecshop/services/reauthorization-model";

/// その他連携サービスサイト認可画面要求(再認可)処理
export class ReauthorizationEcshopService {
  private reauthorizationEcshopApi = new ReauthorizationEcshopApi();

  /**
   * その他連携サービスサイト認可画面要求(再認可)API実行
   */
  public async reauthorizeEcshop(param: ReauthorizationEcshopRequestModel) {
    return await this.reauthorizationEcshopApi.reauthorize(param);
  }
}
